import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';

import PreviewTrack from '../PreviewTrack';
import { slugify, displayDuration } from '../../helpers/view';

import c from './TrackItem.less';

function TrackItem(props) {
  const history = useHistory();
  const {
    track, artist, actions, className, showPosition, playingTrack, showRelease, showLinkToRelease,
  } = props;
  const releaseLink = track.release ? `/release/${slugify(track.release.name, track.release.id)}` : null;

  const handleEndTrack = () => {
    props.onEndTrack();
  };

  const handleReleaseNameClick = (e) => {
    e.preventDefault();
    history.push(releaseLink);
  };

  return (
    <div
      className={classNames(c.trackItem, className, { [c.active]: playingTrack === track.id })}
      id={`track-${track.id}`}
      key={track.id}
    >
      {
        showPosition && <span className={c.position}>{track.position}.</span>
      }
      <PreviewTrack
        src={track.playUrl}
        trackIsPurchased={!!track.downloadUrl}
        trackId={track.id}
        className={c.preview}
        onEnd={handleEndTrack}
        fileSize={track.fileSize}
        ariaLabel={`Play track ${track.name}`}
      />
      <span className={c.title}>
        {
          (showLinkToRelease && track.release) ? (
            <Link to={`${releaseLink}#track-${track.id}`}>{track.name}</Link>
          ) : track.name
        }
        {
          artist.name ? (
            <span className={c.artistName}>
              by <span>{artist.name}</span>
            </span>
          ) : null
        }
        {
          showRelease && track.release ? (
            <span className={c.releaseName}>
              from <a href={releaseLink} onClick={handleReleaseNameClick}>{track.release.name}</a>
            </span>
          ) : null
        }
      </span>
      <span className={classNames(c.duration, 'visible-desktop')}>{displayDuration(track.duration)}</span>
      <div className={c.actions}>{actions}</div>
    </div>
  );
}

TrackItem.propTypes = {
  track: PropTypes.object.isRequired,
  artist: PropTypes.object,
  actions: PropTypes.element,
  className: PropTypes.string,
  showPosition: PropTypes.bool,
  showRelease: PropTypes.bool,
  playingTrack: PropTypes.number,
  showLinkToRelease: PropTypes.bool,
  onEndTrack: PropTypes.func,
};

TrackItem.defaultProps = {
  artist: {},
  actions: null,
  className: null,
  showPosition: false,
  playingTrack: null,
  showRelease: false,
  showLinkToRelease: false,
  onEndTrack: () => null,
};

export default connect(
  (state) => ({
    playingTrack: state.player.playingTrack,
  })
)(TrackItem);
